import React from 'react';
import { Typography, Card, CardContent } from '@material-ui/core';
import { containerStyle } from 'src/components/Subheader/Subheader.styles';
import { PivotInsightData, PivotInsightConfig } from 'src/pages/NavigationShell/Footer/Footer.types';
import { get, has } from 'lodash';

function getConfiguredValue(
  cardKey: keyof PivotInsightConfig['card'],
  config: PivotInsightConfig | null,
  data: PivotInsightData,
): string {
  let value: string = '';
  const dataIndex: keyof PivotInsightData = (config?.card[cardKey] ?? '') as keyof PivotInsightData;

  if (has(data, dataIndex)) {
    value = get(data, dataIndex);
  } else {
    console.warn(`Unable to find a value for ${dataIndex} in data response`);
  }

  return value;
}

interface PivotInsightsProps {
  data: PivotInsightData[];
  onClose: () => void;
  config: PivotInsightConfig | null;
}

export function PivotInsights({ data, onClose, config }: PivotInsightsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '1rem', height: '100%' }}>
      <div
        onClick={onClose}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0.5rem 0',
          cursor: 'pointer',
          marginBottom: '0.5rem',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '4px',
            backgroundColor: '#ccc',
            borderRadius: '2px',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#999';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ccc';
          }}
        />
      </div>
      <div className={containerStyle} style={{ marginBottom: '1rem' }}>
        <h1 className="title">{config?.title}</h1>
      </div>
      <section style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            overflowX: 'auto',
            overflowY: 'hidden',
            paddingBottom: '1rem',
            scrollbarWidth: 'thin',
          }}
        >
          {data.map((insight, index) => (
            <Card
              key={index}
              style={{
                minWidth: '300px',
                maxWidth: '400px',
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              }}
            >
              <CardContent style={{ padding: 0, flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 600,
                    color: '#ffffff',
                    backgroundColor: '#00a89b',
                    fontSize: '1.1rem',
                    padding: '1rem 1.5rem',
                    margin: 0,
                  }}
                >
                  {getConfiguredValue('title', config, insight)}
                </Typography>
                <Typography variant="body1" style={{ color: '#555', lineHeight: 1.6, padding: '1.5rem' }}>
                  {getConfiguredValue('content', config, insight)}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
